import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-delivery-truck-1',
  standalone: true,
  templateUrl: '../../assets/delivery-truck-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDeliveryTruck1Icon {}
